import { render, staticRenderFns } from "./WindowBrokenWindow.vue?vue&type=template&id=9f28510e&scoped=true"
import script from "./WindowBrokenWindow.vue?vue&type=script&lang=ts"
export * from "./WindowBrokenWindow.vue?vue&type=script&lang=ts"
import style0 from "./WindowBrokenWindow.vue?vue&type=style&index=0&id=9f28510e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f28510e",
  null
  
)

export default component.exports